import { UsersAdded } from "../../pages/users/pages/userGroups/pages/permitting/type";

export const updateUserPermission = ({ rowAdded, rowAddedCopy, id }: { rowAdded: UsersAdded[], rowAddedCopy: UsersAdded[], id: string }) => {

    const body = {
        userGroupId: Number(id),
        news: [] as number[],
        deletes: [] as number[],
    };

    const rowAddedMap = new Map(rowAdded.map(item => [item.id, item]));
    const rowAddedCopyIds = new Set(rowAddedCopy.map(item => item.id));

    body.deletes = rowAddedCopy
        .filter(item => {
            const current = rowAddedMap.get(item.id);
            return (
                !current ||
                current.applies === false
            );
        })
        .map(item => item.id);

    body.news = rowAdded
        .filter(item => !rowAddedCopyIds.has(item.id) && item.applies === true)
        .map(item => item.id);

    return { body };
}